/**
 * TableRenderer - 멀티 에이전트 응답의 테이블 데이터 렌더링
 */
import React from 'react';
import { useTranslation } from '../context/LanguageContext';
import './TableRenderer.css';

const TableRenderer = ({ data }) => {
  const { t } = useTranslation();

  if (!data || !data.columns || !data.rows) {
    return <div className="table-error">{t('components.tableRenderer.noData')}</div>;
  }

  const { columns, rows, total_count, displayed_count } = data;

  return (
    <div className="table-renderer">
      <table>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIdx) => (
            <tr key={rowIdx}>
              {row.map((cell, cellIdx) => (
                <td key={cellIdx}>
                  {typeof cell === 'number'
                    ? cell.toLocaleString()
                    : cell !== null && cell !== undefined
                    ? String(cell)
                    : '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {total_count > displayed_count && (
        <div className="table-footer">
          {t('components.tableRenderer.truncated', { displayed: displayed_count, total: total_count.toLocaleString() })}
        </div>
      )}
    </div>
  );
};

export default TableRenderer;
